<template>
  <h2>Configuración</h2>
  <p>Ajustes del sistema. Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam nostrum, ut provident obcaecati debitis quam unde! Tempore, sunt? Temporibus aperiam, dolorem voluptatibus optio deserunt error minus odio ducimus libero eligendi?</p>
</template>
